if ('input[type="checkbox"][0]') {
    $('input[type="checkbox"]').on('click', function() {
        $(this).toggleClass('checkbox-active');
    });
}

$('input[type="file"]').on('change', function() {
    let fileName = $(this)
        .val()
        .replace(/C:\\fakepath\\/i, '');
    $(this)
        .closest('.wpcf7-form-control-wrap')
        .next('.upload-path')
        .text(fileName);
});
